import React from "react";
import { useState } from "react";
import usePutRequest from "../../hooks/usePutReq";
import { useNavigate } from "react-router-dom";

const {
  REACT_APP_MOSJID_NAME: mosjid_name,
  REACT_APP_MOSJID_DETAILS_NAME: mosjid_details_name,
  REACT_APP_MOSJID_ADDRESS: mosjid_address,
  REACT_APP_MOSJID_EMAIL_ADDRESS: email_address,
  REACT_APP_MOSJID_CONTACT_NUMBER: contact_number,
  REACT_APP_MOSJID_LOGO: mosjid_logo,
} = process.env;

const PaymentReceipt = ({ message, paymentId, onClose }) => {
  const navigate = useNavigate();
  const { onPutRequest } = usePutRequest();
  const [email, setEmail] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  const navigateToHome = () => {
    navigate("/");
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onPutRequest(`/payment/${mosjid_name}/receipt/sent/${paymentId}`, {
      email: email,
      contactNumber: contactNumber,
      pdfHeader: {
        mosjid_name,
        mosjid_details_name,
        mosjid_address,
        email_address,
        contact_number,
        mosjid_logo,
      },
    });
    onClose();
    navigateToHome();
  };

  return (
    <div className="w-full">
      <div className="mb-8">
        <h2 className="text-3xl font-semibold">Status: {message}</h2>
        <h3 className="text-lg font-medium">
          Are you sure you want to receipt via email
        </h3>
      </div>
      <form className="w-full" onSubmit={submitHandler}>
        <input
          type="email"
          className="mb-8 shadow appearance-none border rounded w-full py-4 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
          placeholder="Enter email address"
          required={true}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="text"
          className="mb-8 shadow appearance-none border rounded w-full py-4 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
          placeholder="Enter contact number"
          onChange={(e) => setContactNumber(e.target.value)}
        />
        <div className="flex gap-x-8">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 w-full rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            Sent Receipt
          </button>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 w-full rounded focus:outline-none focus:shadow-outline"
            type="button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentReceipt;
